import React from "react";
// import Header from "./Components/Layout/Header";
import "./index.css";
// import { Router } from "react-router-dom";
import Approutes from "./Routes/Approutes";
// import Footer from "./Components/Layout/Footer";

const App = () => {
  return (
    <>
      <Approutes />
    </>
  );
};

export default App;
